export default __webpack_public_path__ + "static/media/home.1f95274e.svg";